@if (loaderVisible()) {
  <mh-wait-full></mh-wait-full>
}

@if (booting()) {
  <div class="tw-pt-10 tw-text-center">
    <mh-spinner-load></mh-spinner-load>
  </div>
} @else {
  @if (logoutMessage()) {
    <section
      class="tw-my-3 tw-flex tw-w-full tw-items-center tw-justify-between tw-rounded-lg tw-bg-blue-100 tw-p-2 tw-font-rubik tw-text-sm tw-text-blue-900"
      role="status"
    >
      <span>{{ logoutMessage() | translate }}</span>
      <button
        type="button"
        class="far fa-times tw-mr-3 tw-border-0 tw-bg-transparent tw-p-0 tw-text-blue-900"
        [attr.aria-label]="'commons.close' | translate"
        (click)="logoutMessage.set(null)"
      ></button>
    </section>
  }

  @switch (step()) {
    @case ('sso') {
      <mh-sso-step
        [provider]="ssoProvider()"
        [loading]="loading()"
        [errorKey]="errorKey()"
        (continueClicked)="continueWithSso()"
        (backClicked)="goBack()"
      ></mh-sso-step>
    }
    @case ('sso-no-account') {
      <mh-sso-step [noAccount]="true" [email]="email()" (backClicked)="goBack()"></mh-sso-step>
    }
    @case ('mfa') {
      <mh-mfa-step
        [challenge]="challenge()"
        [rememberDeviceAllowed]="rememberDeviceAllowed()"
        [loading]="loading()"
        [errorKey]="errorKey()"
        (verified)="handleMfaVerify($event)"
        (resendRequested)="handleMfaResend()"
        (backRequested)="goBack()"
      ></mh-mfa-step>
    }
    @default {
      <mh-credentials-step
        [initialEmail]="email()"
        [passwordRequired]="step() === 'password'"
        [loading]="loading()"
        [errorKey]="errorKey()"
        [errorParams]="errorParams()"
        (submitted)="handleCredentials($event)"
        (errorDismissed)="clearError()"
        (backRequested)="goBack()"
      ></mh-credentials-step>
    }
  }

  <div
    class="tw-mt-[34px] tw-flex tw-items-center tw-justify-center tw-gap-4 tw-font-rubik tw-text-sm"
    [class.tw-pointer-events-none]="loading()"
    [class.tw-opacity-50]="loading()"
  >
    <select
      class="tw-cursor-pointer tw-rounded-md tw-border tw-border-gray-300 tw-bg-white tw-pl-3 tw-pr-10 tw-py-1.5 tw-text-gray-700 tw-shadow-sm focus:tw-outline-none disabled:tw-cursor-not-allowed"
      [disabled]="loading()"
      (change)="handleLanguageChange($event)"
    >
      @for (iso of availableLanguages; track iso) {
        <option [value]="iso" [selected]="iso === currentLanguage()">{{ 'languages.iso.' + iso | translate }}</option>
      }
    </select>

    <a class="tw-text-main-text tw-underline" [href]="needHelpUrl()" target="_blank">
      {{ 'themes.public.login.need_help' | translate }}
    </a>
    <a class="tw-text-main-text tw-underline" [href]="demoUrl()" target="_blank">
      {{ 'themes.public.login.not_account' | translate }}
    </a>
  </div>
}
